module.exports = __webpack_public_path__ + "static/img/icon_attention.c5a4fd17.png";